import { cn } from '@/lib/utils';

/**
 * Spinner + estados de carga.
 *
 * Es un spinner CSS (sin librería de iconos) para que girar no dependa de nada externo
 * y herede el color del texto (`text-current`).
 */
export function Spinner({ className }: { className?: string }) {
  return (
    <span
      role="status"
      aria-label="Cargando"
      className={cn(
        'inline-block size-4 animate-spin rounded-pill border-2 border-current border-t-transparent',
        className,
      )}
    />
  );
}

/** Carga de una sección dentro del layout (deja el sidebar y el header visibles). */
export function PageLoader({ label = 'Cargando…' }: { label?: string }) {
  return (
    <div className="flex min-h-72 flex-col items-center justify-center gap-3 text-ink-muted">
      <Spinner className="size-6 text-brand-600" />
      <p className="text-caption">{label}</p>
    </div>
  );
}

/** Carga de pantalla completa (ej. antes de resolver la sesión en una ruta protegida). */
export function FullPageLoader({ label = 'Cargando…' }: { label?: string }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-canvas text-ink-muted">
      <Spinner className="size-7 text-brand-600" />
      <p className="text-caption">{label}</p>
    </div>
  );
}
